export enum TipoSituacaoAcordo {
    EM_ANDAMENTO = "EM_ANDAMENTO",
    LIQUIDADO  = "LIQUIDADO",
    CANCELADO = "CANCELADO"
}

export const getSituacaoAcordoFormatado = (situacaoAcordo : TipoSituacaoAcordo) => {
    switch(situacaoAcordo){
        case TipoSituacaoAcordo.EM_ANDAMENTO:
            return 'Em andamento'
        case TipoSituacaoAcordo.LIQUIDADO:
            return 'Liquidado'
        case TipoSituacaoAcordo.CANCELADO:
            return 'Cancelado'
    }

}
